<template>
  <div class="header">
    <div class="header__warp">
      <div class="left-crm" v-if="userInfo.employeeInfoVO.salespersonName">
        <span @click="goHome" class="pointer middle">
          <img class="logo middle" src="@/assets/img/home-icon.png" />
          智云问药首页
        </span>
        <div class="service-tag">
          {{ userInfo.employeeInfoVO.salespersonName }}，您正在为
          <span>{{ userInfo.enterpriseVO.company.name }}</span>
          服务
        </div>
        <span @click="onChange" class="pointer middle">切换其它药店</span>
      </div>
      <div class="left vertical-align" v-else>
        <span @click="goHome" class="pointer middle">
          <img class="logo middle" src="@/assets/img/home-icon.png" />
          智云问药首页
        </span>
        <span
          style="margin-left: 16px"
          v-if="userInfo.enterpriseVO && userInfo.enterpriseVO.company.name"
          class="middle"
        >
          {{ userInfo.enterpriseVO.company.name }}欢迎您！
        </span>
        <span @click="onLogout" class="pointer middle">退出</span>
      </div>
      <div class="right">
        <template v-if="showOpenIm">
          <template v-if="unReadMessageNum && unReadMessageNum > 0">
            <el-badge is-dot class="pointer">
              <span @click="openIm">联系商家</span>
            </el-badge>
          </template>
          <template v-else>
            <span @click="openIm" class="pointer">联系商家</span>
          </template>
        </template>

        <span @click="goPersonalCenter" class="pointer">个人中心</span>
        <el-dropdown class="pointer" @command="handleMyOrderDropdown">
          <span style="font-size: 12px">
            我的订单
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="orderList">我的订单</el-dropdown-item>
            <el-dropdown-item command="refundList">退款/售后</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <span @mouseenter="download = true" @mouseleave="download = false" class="pointer">智云问诊APP</span>
        <div class="download" v-if="download">
          <img class="download_bg" src="@/assets/img/download.png" alt="" />
          <img class="download_qr" src="https://www.zyhealth.com/assets/wenzhen-qr.08ed4f2.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getRouter } from '../../helpers/utils';
import * as api from '@/services';
import { mapState } from 'vuex'
export default {
  name: 'MainHeader',
  computed: {
    ...mapState('USER', {
      userInfo: (state) => state.userInfo
    }),
    showOpenIm() {
      if (this.$store) {
        return true;
      }
    },
    unReadMessageNum() {
      return this.$store.getters['imChatService/getUnReadMessageNum'];
    }
  },
  data() {
    return {
      // userInfo: {},
      download: false,
      router: {}
    };
  },

  created() {
    this.router = getRouter(this.$router);
  },
  mounted() {
    // this.getUserInfo();
  },
  methods: {
    handleMyOrderDropdown(command) {
      if (command === 'orderList') {
        // 订单列表
        this.goOrderList();
      } else {
        // 退款单列表
        this.router.push('/refundList');
      }
    },
    openIm() {
      this.$store && this.$store.dispatch('imDialogService/openDialog');
    },
    async getUnReadMessageNum() {
      this.unReadMessageNum = this.$store ? this.$store.getters['imChatService/getUnReadMessageNum'] : 0;
      setTimeout(() => {
        this.getUnReadMessageNum();
      }, 1000);
    },
    async getUserInfo() {
      this.userInfo = this.$store ? this.$store.state.USER.userInfo : await api.login.getUserInfo();
      if (!this.userInfo.userInfoVO || !this.userInfo.userInfoVO.userId) {
        setTimeout(() => {
          this.getUserInfo();
        }, 1000);
      }
    },
    goPersonalCenter() {
      this.router.push('/personalCenter/index');
    },
    goOrderList() {
      this.router.push('/orderList');
    },
    goHome() {
      this.router.push('/mallHomePage/all');
    },

    async onLogout() {
      await api.login.logout();
      this.router.push('/login');
    },

    async onChange() {
      this.router.push('/crm_selectPharmacy/-1'); // 固定写法，-1 代表当前已登陆，没有crm token
    },

    onDownloadApp() {
      window.location.href = '//static.kminghealth.com/collection/qunyinghui/guideDownloadApp.html';
    }
  }
};
</script>

<style lang="scss" scoped>
.header__warp {
  height: 100%;
}
.header {
  min-width: 1232px;
  height: 34px !important;
  padding: 0;
  background: #f4f4f4;
  &__warp {
    display: flex;
    width: 1232px;
    margin: auto;
    justify-content: space-between;
    .left,
    .right {
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      display: flex;
      align-items: center;
      position: relative;
      //line-height: 34px;
      .pointer {
        margin-left: 16px;
        &:nth-child(1) {
          margin-left: 0;
        }
        /deep/.el-badge__content.is-fixed {
          top: 0px;
        }
      }
    }
  }
}
.pointer {
  cursor: pointer;
}
.logo {
  width: 16px;
  height: 16px;
  margin-right: 1px;
  margin-top: -3px;
}
.download {
  width: 198px;
  height: 274px;
  position: absolute;
  right: 0;
  top: 32px;
  bottom: 0;
  z-index: 101;
  &_bg {
    width: 198px;
    height: 274px;
  }
  &_qr {
    width: 100px;
    height: 100px;
    position: relative;
    bottom: 125px;
    left: 47px;
  }
}
.left-crm {
  display: flex;
  align-items: center;
  .middle {
    color: #999999;
    font-size: 14px;
    line-height: 14px;
  }
  .pointer {
    font-size: 12px;
    line-height: 12px;
    color: #1e8dff;
  }
  .service-tag {
    padding: 6px 16px;
    font-size: 14px;
    line-height: 14px;
    font-weight: 500;
    color: #ffffff;
    background: #ff4d4f;
    border-radius: 14px;
    margin: 0 12px 0 16px;
    span {
      color: #d2ff4f;
    }
  }
}
</style>
